function applyScript() {
  setTimeout(function(){
   // Get all elements with class ".bold_option_value"
   var optionElements = document.querySelectorAll('.bold_option_value');
   console.log("BOLD==>")
 
   // Loop through each option element
   optionElements.forEach(function(optionElement) {
     // Check if the option has a swatch
     var swatchElement = optionElement.querySelector('.bold_option_value_swatch span');
     if (swatchElement) {
       // Get the background URL from the style attribute
       var backgroundUrl = swatchElement.style.backgroundImage;
       // Extract the URL from the background image value
       var imageUrl = backgroundUrl.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
       
       // Create a new span element with class "hover_image"
       var hoverImageElement = document.createElement('span');
       hoverImageElement.classList.add('hover_image');
       
       // Create an img element
       var imgElement = document.createElement('img');
       imgElement.src = imageUrl;
       
       // Append the img element to the "hover_image" span
       hoverImageElement.appendChild(imgElement);
       
       // Append the "hover_image" span to the "bold_option_swatch_title" element
       var swatchTitleElement = optionElement.querySelector('.bold_option_value_title');
       swatchTitleElement.prepend(hoverImageElement);
     }
   });
 },500)
}

function observeDOM() {
var observer = new MutationObserver(function(mutationsList) {
 for (var mutation of mutationsList) {
   if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
     applyScript();
     observer.disconnect();
     break;
   }
 }
});

observer.observe(document.body, {
 childList: true,
 subtree: true
});
}

document.addEventListener('DOMContentLoaded', function() {
observeDOM();
});

setTimeout(function(){
 // Get all elements with class ".bold_option_value"
 var labelElements = document.querySelectorAll('.color-swatch'); 

 // Loop through each option element
 labelElements.forEach(function(labelElement) {

     var swatchElement = labelElement.querySelector('.color-swatch label');
     if (swatchElement) {
         // Get the background URL from the style attribute
         var backgroundUrl = swatchElement.style.backgroundImage;
         // Extract the URL from the background image value
         var imageUrl = backgroundUrl.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
             
         // Create a new span element with class "hover_image"
         var hoverImageElement = document.createElement('span');
         hoverImageElement.classList.add('hover_img'); 
         
         // Create an img element
         var imgElement = document.createElement('img');
         imgElement.setAttribute('width', '300');
         imgElement.setAttribute('height', '300');
         imgElement.src = imageUrl;
         
         // Append the img element to the "hover_image" span
         hoverImageElement.appendChild(imgElement);
         
         // Append the "hover_image" span to the "bold_option_swatch_title" element
         var swatchTitleElement = labelElement.querySelector('.color-swatch--tooltips');
         swatchTitleElement.prepend(hoverImageElement);
     } 
 });
},500)